export default __webpack_public_path__ + "static/media/Water_resources_W.8453c7b3.png";